const CategoriesName = {
  logistic: 'Logistique',
  unfold: 'Dépliage et relevage',
  folding: 'Repliage',
  juxtaposition: 'Juxtaposition',
  superposition: 'Superposition',
};

export default CategoriesName;
